import store from "../store";
import {
  setAgDetails,
  setLoading,
  setPaginationTotalCount,
  setVersion,
  setVersionDate,
} from "../store/slices/commonSlice";
import api from "../utils/interface";

let debounceTimeout;
const debounce = (func, delay) => {
  return function (...arg) {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => func.apply(this, arg), delay);
  };
};

export const getFilteredDataWithTabs = debounce(
  (entityType, functionName, data, params) => {
    // const setLoadingTimeout = setTimeout(() => {
    //   store.dispatch(setTableLoading(true));
    // }, 300);
    store.dispatch(setLoading(true));

    let updatedParams = { ...params };
    let updatedData = { ...data };

    //   if (activeTab !== "ALL") {
    //     // updatedData = { ...updatedData, [matchedStatusKey]: activeTab };

    //     updatedParams = {
    //       ...updatedParams,
    //       tab_column: matchedStatusKey,
    //       tab_value: activeTab,
    //     };
    //   }

    if (!updatedParams?.sort_column) delete updatedParams?.sort_order;
    if (updatedData?.parent_id || updatedData?.parent_type) {
      updatedParams = {
        ...updatedParams,
        parent_id: updatedData?.parent_id,
        parent_type: updatedData?.parent_type,
      };
    }

    delete updatedParams.from_date;
    delete updatedParams.to_date;
    delete updatedParams?.column;
    delete updatedParams?.value;

    delete updatedData?.parent_id;
    delete updatedData?.parent_type;

    api
      .post(`/entity/getFilteredDataWithTabs/${entityType}`, updatedData, {
        params: updatedParams,
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res && res.status === 200) {
          store.dispatch(functionName(res?.data.entity_list));
          store.dispatch(
            setPaginationTotalCount(res.data.entity_tab[0]?.tab_value_count)
          );
          store.dispatch(setLoading(false));
          // clearTimeout(setLoadingTimeout);
          // rootReducer.dispatch(setTableLoading(false));
        }
      })
      .catch(() => {
        store.dispatch(setLoading(false));
        // clearTimeout(setLoadingTimeout);
        // rootReducer.dispatch(setTableLoading(false));
      });
  },
  1000
);

export const getVersion = async () => {
  const response = await api.get(`/dev/version`);
  if (response && response.status === 200) {
    store.dispatch(setVersion(response.data.marketplace_version));
    store.dispatch(setVersionDate(response.data.marketplace_version_date));
    return response.data;
  }
};

export const getAgDetailsByBaseUrl = async (baseUrl) => {
  const response = await api.get(`/agsp/useraccount/getAgDetailsByBaseUrl`, {
    params: {
      baseUrl: baseUrl, // Add the baseUrl query parameter
    },
  });

  if (response && response.status === 200) {
    store.dispatch(setAgDetails(response.data));
    return response.data;
  }
};

export const downloadDocument = async (
  media_id,
  file_name = "downloaded-file"
) => {
  try {
    const res = await api.get(`/media/download/${media_id}`, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
      },
    });

    // Check if the Content-Type header is available in the response
    const contentType = res.headers["content-type"];

    // Set MIME type accordingly
    let mimeType = "application/octet-stream"; // Default type
    if (contentType) {
      mimeType = contentType; // Use the actual Content-Type from the response
    }

    const blob = new Blob([res.data], { type: mimeType });
    const url = window.URL.createObjectURL(blob);

    var a = document.createElement("a");
    a.href = url;
    a.download = file_name;
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error(error);
    // showToast(error.response?.data?.error_message, "error");
  }
};
